<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path fill-rule="evenodd" d="m1.042 3.165 1.065-1.057L15.892 15.9l-1.057 1.057-1.208-1.207H3.75c-.825 0-1.5-.675-1.5-1.5V4.373L1.042 3.165ZM3.75 5.873v8.377h8.378l-1.5-1.5H4.5l2.25-3L8.437 12l.615-.825L3.75 5.873Z" clip-rule="evenodd"/>
    <path d="M14.25 12.127V3.75H5.872l-1.5-1.5h9.878c.825 0 1.5.675 1.5 1.5v9.877l-1.5-1.5Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
